/**
 * TanStack Query hooks for `flat-fee-cpa-cpl-cpi-cps-cpc-revshare-hybrid-payou`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys,
	type CreateFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouBody,
	type ListFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouResponse,
	type FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow,
} from "./api";

export function useFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouList(): UseQueryResult<ListFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouResponse, Error> {
	return useQuery({
		queryKey: flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys.list(),
		queryFn: list,
	});
}

export function useFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouCreate(): UseMutationResult<FlatFeeCpaCplCpiCpsCpcRevshareHybridPayouRow, Error, CreateFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys.all });
		},
	});
}

export function useFlatFeeCpaCplCpiCpsCpcRevshareHybridPayouDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: flatFeeCpaCplCpiCpsCpcRevshareHybridPayouQueryKeys.all });
		},
	});
}
